export default __webpack_public_path__ + "static/media/amazonecho.7c4bc075.jpg";